/**
 * 全局loading组件
 * author: lifeng05
 */
import React from 'react';
import styles from './index.module.scss';

type LoadingType = 'big' | 'small';

interface ILoadingProps {
  type?: LoadingType; // default - 全局loading;  local - 局部loading
  description?: string; // loading 图标下方文字描述
  colorFul?: boolean; // 是否是彩色
  isTransparent?: boolean; // 是否半透明
  height?: number; // 当loading为 small类型时,设定高度,默认px(40)
  zIndex?: number;
}

const Loading = (props: ILoadingProps) => {
  const {
    type = 'big',
    description,
    colorFul = false,
    isTransparent = false,
    height,
    zIndex = 0
  } = props;
  return (
    <div
      className={`${styles['loading-container']} ${styles[type]}`}
      style={{
        backgroundColor: isTransparent ? `rgba(255, 255, 255, 0.5)` : '',
        height: height ? `${height}px` : 'auto',
        zIndex
      }}
    >
      <span className={`icon-img icon-loading ${styles['icon-loading']}`} />
      {description && <p>{description}</p>}
    </div>
  );
};

export default Loading;
